<template>
  <div class="xscontainer jsjiesh">
    <div class="dsfsdfd">
      <div class="kknnvh">
<!--        <p class="biaoti1">我要参加培训</p>-->
      </div>
      <div class="coldiv">
        <p class="biaoti2_blue">课程及考试安排</p>
<!--        <el-table-->
<!--            cell-style="height:3rem"-->
<!--            :data="tableData"-->
<!--            style="width: 100%">-->
<!--          <el-table-column type="expand">-->
<!--            <template slot-scope="props">-->
<!--              <el-form label-position="left" inline class="demo-table-expand">-->
<!--                <el-form-item label="课程名称">-->
<!--                  <span>{{ props.row.cname }}</span>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="课程分类">-->
<!--                  <span>{{ props.row.kcfenlei }}</span>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="课程介绍">-->
<!--                  <span>{{ props.row.dagang }}</span>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="主讲讲师">-->
<!--                  <span>{{ props.row.zhujiangren }}</span>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="时间">-->
<!--                  <span>{{ props.row.shijian }}</span>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="地点">-->
<!--                  <span>{{ props.row.didian }}</span>-->
<!--                </el-form-item>-->

<!--              </el-form>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              prop="cname"-->
<!--              width="240"-->
<!--              label="课程名称">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              prop="dagang"-->
<!--              width="340"-->
<!--              label="课程介绍">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              prop="kcfenlei"-->
<!--              label="课程分类">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              prop="zhujiangren"-->
<!--              label="主讲讲师">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              prop="shijian"-->
<!--              width="100"-->
<!--              label="时间">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              prop="didian"-->
<!--              width="100"-->
<!--              label="地点">-->
<!--          </el-table-column>-->
<!--        </el-table>-->

        <table>
          <thead>
          <tr>
            <th style="width: 12%;">课程及考试名称</th>
            <th style="width: 9%;">课程及考试分类</th>
            <th style="width: 23%;">课程及考试介绍</th>
            <th style="width: 7%;">主讲讲师</th>
            <th style="width: 5%;">时间</th>
            <th style="width: 10%;">地点</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in tableData">
            <td>{{item.cname}}</td>
            <td>{{item.kcfenlei}}</td>
            <td v-html="item.dagang"></td>
            <td>{{item.zhujiangren}}</td>
            <td>{{item.shijian}}</td>
            <td>{{item.didian}}</td>
          </tr>
          </tbody>
        </table>
        <el-pagination
            align="center"
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="currentPage1"
            :page-sizes="[3, 6, 9, 12]"
            :page-size="pagesize1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1">
        </el-pagination>
      </div>
      <div class="coldiv">
        <p class="biaoti2_blue">认证证书</p>
        <div class="dkll">
          <div class="nklldfd">
            <el-carousel indicator-position="outside">
              <el-carousel-item>
                <img class="werewre" src="@/assets/xxkc/zhengshu/zhengshu104.jpg"  />
              </el-carousel-item>
              <el-carousel-item>
                <img class="werewre" src="@/assets/xxkc/zhengshu/zhengshu102.jpg"  />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="sdfserwerwrew">
            <div class="fddsfe">参加培训后，可获得相应证书</div>
            <table>
              <tbody>
              <tr>
                <td class="td_1">姓名</td>
                <td class="td_2">XXX</td>
              </tr>
              <tr>
                <td class="td_1">证书类型</td>
                <td class="td_2" >单项/统认</td>
              </tr>
              <tr>
                <td class="td_1">星数</td>
                <td class="td_2">一/二/三/四/五</td>
              </tr>
              <tr>
                <td class="td_1">相关方向</td>
                <td class="td_2">数据架构/数据质量/数据安全/数据资产等</td>
              </tr>
              <tr>
                <td class="td_1">证书名称</td>
                <td class="td_2">DQM/DGPA等</td>
              </tr>
              <tr>
                <td class="td_1">发证日期</td>
                <td class="td_2">XXXX年XX月XX日</td>
              </tr>
              <tr>
                <td class="td_1">发证机构</td>
                <td class="td_2">国际数据治理协会</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="coldiv">
        <p class="biaoti2_blue">参训报名</p>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="团体身份" prop="shenfen">
            <el-radio-group v-model="ruleForm.shenfen">
              <el-radio label="甲方" ></el-radio>
              <el-radio label="IT公司"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="学习内容" prop="fenlei">
            <el-checkbox-group v-model="ruleForm.fenlei">
              <el-checkbox :label="item.dictname" name="type" v-for="(item,index) in fenleis"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="企业名称" prop="qymc">
            <el-input v-model="ruleForm.qymc"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机号" prop="sjh">
                <el-input v-model="ruleForm.sjh"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱" prop="youxiang">
                <el-input v-model="ruleForm.youxiang"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <el-form-item label="可参加时间" prop="shijian">
                <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.shijian" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <div class="lllls">
                <el-form-item label="团体人数" prop="renshu" style="width: 70%">
                  <el-input v-model="ruleForm.renshu"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="lllls">
                <p class="hanggao" style="margin-left: 10px;color: red;">*</p>
                <p class="hanggao">团体报名人数须满足≥</p>
                <p class="hanggao" style="color: red">20</p>
                <p class="hanggao">人</p>
              </div>
            </el-col>
          </el-row>
          <el-form-item label="目前所在地" prop="suozaidi">
            <el-input v-model="ruleForm.suozaidi"></el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="beizhu">
            <el-input type="textarea" v-model="ruleForm.beizhu"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="mkl">
        <div class="mybtn" @click="resetForm('ruleForm')">重置</div>
        <div class="mybtn" @click="submitForm('ruleForm')">提交</div>
      </div>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
export default {
  name: 'Xianxianxuexi',
  components:{},
  data() {
    return {
      tableData: [],
      ruleForm: {
        shenfen:'',
        fenlei: [],
        xingming:'',
        qymc:'',
        sjh:'',
        youxiang:'',
        shijian:'',
        renshu:'',
        suozaidi:'',
        beizhu:''
      },
      rules: {
        xingming: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        shenfen: [
          { required: true, message: '请选择身份', trigger: 'change' },
        ],
        fenlei: [
          { required: true, message: '请选择学习内容', trigger: 'change' },
        ],
        qymc: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
        ],
        sjh: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {  pattern: /^1[3-9]\d{9}$/,  message: '请输入正确的手机号', trigger: ['blur'] }
        ],
        youxiang: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        shijian: [
          { required: true, message: '请输入可参加时间', trigger: 'blur' },
        ],
        renshu: [
          { required: true, message: '请输入人数', trigger: 'blur' },
        ],
        suozaidi: [
          { required: true, message: '请输入目前所在地', trigger: 'blur' },
        ],
      },
      pagesize1:3,
      currentPage1: 1,
      total1:0,
      fenleis:[],
      fwcishu:0
    }
  },
  mounted() {
    this.querykc();
    this.queryFenlei();
  },
  created() {
    this.tongji('我要参加培训');
  },
  methods: {
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    handleSizeChange1(val) {
      this.pagesize1 = val;
      this.querykc();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.querykc();
    },
    queryFenlei(){
        var that = this;
        this.$ajax
            .get(this.GLOBAL.sys_addr + '/tdict/tDict/list?_t='+new Date().getTime()+'&column=id&order=asc&groupname=学习内容&pageNo='+0+'&pageSize='+8)
            .then(function (response) {
              if (response.data.code == 200) {
                debugger
                that.fenleis  = response.data.result.records;
              } else {
                that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
              }
            });
    },
    querykc(){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/xianxiacourse/tXianxiaCourse/list?_t='+new Date().getTime()+'&column=id&order=asc&pageNo='+this.currentPage1+'&pageSize='+this.pagesize1)
          .then(function (response) {
            if (response.data.code == 200) {
              that.tableData  = response.data.result.records;
              that.currentPage1 = response.data.result.current;
              that.total1 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('您确认提交吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var that = this;
            let ss = '';
            debugger
            let mes = this.ruleForm.fenlei;
            for (var i in mes) {
              ss += mes[i]+",";
            }
            ss = ss.substring(0,ss.length-1);
            let dd = JSON.stringify(this.ruleForm);
            dd = JSON.parse(dd);
            dd.fenlei = ss;
            this.$ajax
                .post(this.GLOBAL.sys_addr + '/woyaopeixun/tWoyaopeixun/add',dd)
                .then(function (response) {
                  if (response.data.code == 200) {
                    that.$notify.success('报名成功！请耐心等待客服人员与你联系。');
                  } else {
                    that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
                  }
                });
          }).catch(() => {
          });


        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style  scoped>
.dsfsdfd{
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  margin-top: -6rem;
}
.kknnvh{
  display: flex;
  justify-content: center;
}
.mkl{
  width: 100%;
  height: 2rem;
  background-color: #f5fafe;
  display: flex;
  justify-content: center;
  align-items: center;
  gap:2rem;
}
.mybtn{
  width: 10%;
  height: 1.6rem;
  line-height: 1.6rem;
  text-align: center;
  border:1px solid #54abf1;
  background-color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  color: #54abf1;
}
.mybtn:hover{
  cursor: pointer;
  color: #ffffff;
  background-color: #54abf1;
}
.dkll{
  width: 100%;
  display: flex;
  gap: 2rem;
}
.zss{
  width: 30rem;
  height: 20rem;
}
.nklldfd{
  width: 40rem;
}
/deep/.el-carousel__container {
  position: relative;
  width:100%;
  height:30rem;
}
.werewre{
  width: 100%;
  height: 100%;
}
.sdfserwerwrew{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.knclks{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
}
.cnnckd{
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.nccsl{
  height: 1.5rem;
  line-height: 1.5rem;
  width: 6rem;
  background-color: #eeeded;
  text-align: center;
  font-weight: bold;
  font-size: 0.9rem;

}
.zitidax{
  height: 1.5rem;
  line-height: 1.5rem;
  font-size: 0.9rem;
  letter-spacing: 0.1rem;
}
.fddsfe{
  font-size: 0.9rem;
  letter-spacing: 0.1rem;
  margin-bottom: 5px;
  font-weight: bold;
  text-align: center;
}
.lllls{
  display: flex;
  flex-wrap: wrap;
}
.ddfg{
  font-weight: bold;
}
.el-form-item{
  margin-bottom: 2rem;
}

.td_1 {
  width: 30%;
  color: #4e83c5;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
}

.td_2 {
  color: #4e83c5;
  width: 70%;
  text-align: center;
  font-size: 14px;
}

/* 基础表格样式 */
table {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
}

/* 表头样式 */
th {
  background-color: #f2f2f2;
  color: #333;
  font-weight: bold;
  padding: 10px;
  text-align: left;
  border: 1px solid #ddd;
}

/* 单元格样式 */
td {
  padding: 13px;
  border: 1px solid #ddd;
}

/* 隔行变色效果 */
tr:nth-child(even) {
  //background-color: #f9f9f9;
}

/* 鼠标悬停效果 */
tr:hover {
  //background-color: #f1f1f1;
}

</style>
